import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./DietPop.module.scss";
import Select from "react-select";
import { useForm } from "react-hook-form";
import {
  useAddDietMutation,
  useUpdateDietMutation,
} from "../../../store/services/dietService";
import toast from "react-hot-toast";

const mealOptions = [
  { value: "Breakfast", label: "Breakfast" },
  { value: "Lunch", label: "Lunch" },
  { value: "Dinner", label: "Dinner" },
];

const DietPop = ({ title, modalOpen, setModalOpen, edit }) => {
  console.log("edit", edit);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      name: edit?.name || "",
      description: edit?.description || "",
      status: edit?.status || "active",
      allergy: edit?.allergy || "",
    },
  });
  const [selectedDiets, setSelectedDiets] = useState(
    edit?.mealType
      ? mealOptions.filter((option) => edit.mealType.includes(option.value))
      : []
  );
  const [addDiet, { isLoading: isAdding }] = useAddDietMutation();
  const [updateDiet, { isLoading: isUpdating }] = useUpdateDietMutation();

  // Submit handler
  const onSubmit = async (data) => {
    try {
      if (edit !== null) {
        // Update existing meal
        await updateDiet({
          mealId: edit._id,
          updatedData: data,
        });
      } else {
        await addDiet(data).unwrap(); // Call deleteDiet and handle success
      }
      setModalOpen(false);
      return toast.success(`Diet ${edit ? "updated" : "added"} successfully`);
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      show={modalOpen}
      className={`${styles.DietPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Col lg="12" md="12" className="my-2">
                {/* Name Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Name
                  </label>
                  <input
                  placeholder="Enter name"
                    type="text"
                    className="form-control"
                    // {...register("name", { required: "Please enter name" })}
                    {...register("name", {
                      required: "Please enter name",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "Name cannot start with a space";
                        }
                        // if (/[^a-zA-Z0-9\s]/.test(value)) {
                        //   return "Name cannot include special characters or emojis";
                        // }
                        return true;
                      },
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </div>

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Description
                  </label>
                  <textarea
                  placeholder="Enter description"
                    type="text"
                    className="form-control"
                    // {...register("name", { required: "Please enter name" })}
                    {...register("description", {
                      // required: "Please enter description",
                      // validate: (value) => {
                      //   if (/^\s/.test(value)) {
                      //     return "Description cannot start with a space";
                      //   }
                      //   if (/[^a-zA-Z0-9\s]/.test(value)) {
                      //     return "Name cannot include special characters or emojis";
                      //   }
                      //   return true;
                      // },
                    })}
                  />
                  {errors.description && (
                    <span className="text-danger">{errors.description.message}</span>
                  )}
                </div>

                {/* Allergy Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Is it for allergy
                  </label>
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="yes"
                        {...register("allergy", {
                          required: "Allergy is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Yes
                      </label>
                    </li>
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="no"
                        {...register("allergy", {
                          required: "Allergy is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        No
                      </label>
                    </li>
                  </ul>
                  {errors.allergy && (
                    <span className="text-danger">{errors.allergy.message}</span>
                  )}
                </div>

                {/* Status Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Status
                  </label>
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="active"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Active
                      </label>
                    </li>
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="inactive"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Inactive
                      </label>
                    </li>
                  </ul>
                  {errors.status && (
                    <span className="text-danger">{errors.status.message}</span>
                  )}
                </div>
              </Col>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>

          {/* <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100"
              >
                {title}
              </Button>
            </div>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DietPop;
